import React from 'react'

export const EmptyMessageTable = ({ newUserClick, message }) => {
  return (
    <>
      <br />
      <div className="text-body black textcenter">{message}</div>
      <div className="text-body black margin-top-small textcenter">
        Click{' '}
        <span onClick={newUserClick} className="blue underline clickable">
          New Customer
        </span>{' '}
        to get started!{' '}
      </div>
    </>
  )
}
